var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m7.455 1.779 1.193-1.2A1.946 1.946 0 0 1 10.035 0h.005a1.966 1.966 0 0 1 1.81 1.205 1.948 1.948 0 0 1-.422 2.129l-1.206 1.201zm-.777.782L.106 9.175A.365.365 0 0 0 0 9.433v2.2A.365.365 0 0 0 .368 12h2.209a.37.37 0 0 0 .26-.107l6.604-6.58z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/Pen.b751ec342882a60650018a1066a6da2c.svg";
export { ForwardRef as ReactComponent };